import { render, staticRenderFns } from "./AppNavigateBack.vue?vue&type=template&id=59a55132"
import script from "./AppNavigateBack.vue?vue&type=script&lang=js"
export * from "./AppNavigateBack.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports